import { Box } from '@startuptools/ui/Box';
import { Card } from '@startuptools/ui/Card';
import { IconButton } from '@startuptools/ui/IconButton';
import { Sheet } from '@startuptools/ui/Sheet';
import { Stack } from '@startuptools/ui/Stack';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { type ComponentProps, Suspense, useState } from 'react';
import {
  MeetingMinutesWithUploadsDocument,
  useMeetingMinutesWithUploadsSuspenseQuery,
} from './MeetingMinutesWithUploads.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { MeetingMinutesDocument } from './MeetingMinutes';
import { MeetingUploads } from './MeetingUploads';
import { useApolloClient } from '@apollo/client';

const MeetingMinutesWithUploadsInner = ({
  meetingId,
  defaultExpanded = false,
}: {
  meetingId: string;
  defaultExpanded?: boolean;
}) => {
  const companyId = useCompanyId();
  const apollo = useApolloClient();
  const [expanded, setExpanded] = useState(defaultExpanded);

  const {
    data: { meeting, companySubscription },
  } = useMeetingMinutesWithUploadsSuspenseQuery({
    variables: { companyId, meetingId },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <Card>
      <Stack direction="row" gap={1} justifyItems="center">
        <Box>
          <IconButton variant="outlined" onClick={() => setExpanded(!expanded)}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
        <MeetingMinutesDocument meeting={meeting} hasActiveSubscription={Boolean(companySubscription?.isActive)} />
      </Stack>
      {expanded && (
        <Sheet variant="soft" sx={{ padding: 2 }}>
          <MeetingUploads
            meeting={meeting}
            refetch={() => apollo.refetchQueries({ include: [MeetingMinutesWithUploadsDocument] })}
          />
        </Sheet>
      )}
    </Card>
  );
};

export const MeetingMinutesWithUploads = (props: ComponentProps<typeof MeetingMinutesWithUploadsInner>) => {
  return (
    <Suspense>
      <MeetingMinutesWithUploadsInner {...props} />
    </Suspense>
  );
};
